import type { SerializedAuthenticatedUser } from '@dmp/qqms/data-access';
import { useShallow } from 'zustand/react/shallow';
import {
    getCurrentUser,
    setCurrentUser,
    useUserStore,
} from '../state/use-user-store';
import { useViewAs } from './use-view-as';

/**
 * Get the current user
 * @return [userWithViewAsPermissionGroup, setCurrentUser, currentUser]
 * - `userWithViewAsPermissionGroup`: the current user with replaced view-as permission group
 * - `currentUser`: the original current user without modified permissions.
 */
export const useCurrentUser = () => {
    const currentUser = useUserStore(useShallow(getCurrentUser));
    const [viewAsRole] = useViewAs();

    const userWithViewAsPermissionGroup:
        | SerializedAuthenticatedUser
        | undefined = currentUser
        ? {
              ...currentUser,
              permissionGroup: viewAsRole || currentUser.permissionGroup,
          }
        : undefined;

    return [
        userWithViewAsPermissionGroup,
        setCurrentUser,
        currentUser,
    ] as const;
};
